import { PAGE_MODULES } from "enums/pageModules";

const CAROUSEL_DEFAULT_AUTOPLAY = 5;

const CATEGORY_ROW_MAX_LIMIT = {
  [`${PAGE_MODULES.CATEGORY_ROW}-rank`]: 10,
  [`${PAGE_MODULES.CATEGORY_ROW}-feature`]: 15,
  [`${PAGE_MODULES.MODULE_SLIDER}`]: 5,
};

const MOSAIC_VIEW_DEFAULT_LIMIT = 20;

export { CAROUSEL_DEFAULT_AUTOPLAY, CATEGORY_ROW_MAX_LIMIT, MOSAIC_VIEW_DEFAULT_LIMIT };
